/** A box name as the slug `boxes.create` takes: lowercase letters, digits and dashes, ≤ 80. */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}
